import { useState, useEffect, useCallback } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import { links, API } from '../../Http/Http';
import { selectIsAuthenticated } from '@store/userData/selectors';

const TICK_DELAY = 30000;
const listenerOptions = { once: false } as EventListenerOptions;

const useHeartbeat = (setError: Dispatch<SetStateAction<number>>) => {
	const [canSend, setCanSend] = useState(true);
	const isAuthenticated = useSelector(selectIsAuthenticated);

	const performRequest = useCallback(async () => {
		if (!canSend) return;
		try {
			setCanSend(false);
			await API.post(links.general.heartBeat);
		} catch (e) {
			setError(e);
		}
	}, [canSend, setError]);

	useEffect(() => {
		if (!isAuthenticated) return;

		window.addEventListener('wheel', performRequest, listenerOptions);
		window.addEventListener('click', performRequest, listenerOptions);
		window.addEventListener('keydown', performRequest, listenerOptions);

		return () => {
			if (!isAuthenticated) return;

			window.removeEventListener('wheel', performRequest, listenerOptions);
			window.removeEventListener('click', performRequest, listenerOptions);
			window.removeEventListener('keydown', performRequest, listenerOptions);
		};
	}, [isAuthenticated, performRequest]);

	useEffect(() => {
		const ticker = setInterval(() => setCanSend(true), TICK_DELAY);
		return () => clearInterval(ticker);
	}, []);
};
export default useHeartbeat;
